import type { Alpha2CountryCode } from '@/lib/types/alpha2CountryCode'
import type { SendRequestType } from '@/lib/utils/shared/httpTools'
import httpTools from '@/lib/utils/shared/httpTools'
import type { ShippingMethodType } from '@/store/types/order'

type Props = {
  alpha2: Alpha2CountryCode
  state: string
  shippingCountry: string
  selectableShippingCountries?: Alpha2CountryCode[]
}

export type HydraGetShippingMethodsResponse = {
  items: ShippingMethodType[]
}

export const HydraGetShippingMethods = ({
  alpha2,
  state,
  shippingCountry,
  selectableShippingCountries,
}: Props) => {
  const destination = selectableShippingCountries?.find(
    (country) => country === shippingCountry && shippingCountry !== alpha2,
  )

  const getMarket = () => {
    if (alpha2 === 'US' && state === 'PR') return 'PR'

    return alpha2
  }

  const request: SendRequestType = {
    method: 'GET',
    url: `/shippingmethods.json?market=${getMarket()}${
      destination ? `&destination=${destination}` : ''
    }`,
    withAuth: false,
  }

  return httpTools.sendRequest<HydraGetShippingMethodsResponse>(request)
}
